export enum OtherSettingsType {
    SupportContact = 1,
    RequestAccess = 2,
    SmtpServer = 3,
    SiteDesign = 4,
    TransferOwnership = 5,
    LoginReminder = 6,
    DataFieldBusinessUnit = 100, // special case for data fields in other settings
    DataFieldUser = 101, // special case for data fields in other settings
    Personalkollen = 200, // special case for PK module in other settings
    BalooELearning = 201, // special case for Baloo e-learning module in other settings
    Planday = 202, // special case for Planday module in other settings
    Billing = 300, // special case for Billing module in other settings
    Agreements = 400, // special case for Agreements module in other settings
    OrganizationImport = 500, // special case for Agreements module in other settings
    HandbookImport = 600, // special case for Agreements module in other settings
}
